import React, {useState} from "react";
import BasicFarmyModal from "./BasicFarmyModal";
import useModalQueue from "./useModalQueue";
import {t} from "../../../shared-services/translate";
import styled from "styled-components";
import useProductsFetcher from "../../products/useProductsFetcher";
import {RjsProductList} from "../../../react-components/RjsProductList";
import {error} from "autoprefixer/lib/utils";
import HorizontalScrollProductList from "../../products/product-lists/HorizontalScrollProductList";

// Named set will be "related_products" until the "bought_together" model is trained.
const AlsoBoughtModal = () => {
  const modalName = "AlsoBoughtModal";
  const limitTo = 20;
  const minProducts = 2;

  const {loadArbitrarySet} = useProductsFetcher();
  const {closeModal} = useModalQueue(modalName);

  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const onClose = () => {
    if (products?.length) {
      sessionStorage.setItem("also_bought_modal_shown", "true");
      sessionStorage.removeItem("also_bought_modal_counter");
      setProducts([]);
    }
  };

  const beforeOpen = (modal = null) => {
    return new Promise((resolve, reject) => {
      if (products.length === 0) {
        setIsLoading(true);
        const {productID} = modal;
        const namedSet = "bought_together";

        loadArbitrarySet({namedSet, productID, limitTo, minProducts})
          .then(response => {
            if (response?.length) {
              setProducts(response);
              resolve(response);
            } else {
              closeModal();
              reject(error("No products found"));
            }

            setIsLoading(false);
          })
          .finally(() => setIsLoading(false));
      } else resolve(products);
    });
  };

  const parentProps = {
    className: "also-bought-products-modal",
    style: {maxWidth: "100%", width: "100%"},
    modalName,
    onClose,
    beforeOpen,
    closeOnLocationChange: true
  };

  return <BasicFarmyModal
    {...parentProps}
    className='also-bought-products-modal'>
    <StyledAlsoBoughtModal>
      <h2>{t("modals.also_bought.title")}</h2>
      <HorizontalScrollProductList
        ProductList={RjsProductList}
        products={products}
        isLoading={isLoading}
        hideMoreButton={true}
        stopAutoScroll={true}
        trackingListName={modalName}
        callerLocation={modalName}
        onProductClick={closeModal}
      />
    </StyledAlsoBoughtModal>
  </BasicFarmyModal>;
};

export default AlsoBoughtModal;

export const StyledAlsoBoughtModal = styled.div`
  width: 100%;
`;
